module.exports = __webpack_public_path__ + "assets/images/rbyearend-11-desktop.jpg?v=f9f053e0";